module.exports = __webpack_public_path__ + "img/undraw_reading_0re1.7d5ecf3e.svg";